import { UseQueryResult } from "@tanstack/react-query";
import { ExtendedAccount } from "@features/depots/types";

export type CurrencyType = "global" | "account";

export type QuerySpec = {
  accountId: number;
  currencyType: CurrencyType;
  displayCurrency?: string;
};

export type QueriesByAccount<T> = Record<
  number,
  Partial<Record<CurrencyType, UseQueryResult<T, unknown>>>
>;

export const groupByAccountAndCurrency = <T>(
  specs: QuerySpec[],
  results: UseQueryResult<T, unknown>[]
): QueriesByAccount<T> =>
  specs.reduce<QueriesByAccount<T>>((acc, spec, i) => {
    const bucket = acc[spec.accountId] ?? {};
    bucket[spec.currencyType] = results[i];
    acc[spec.accountId] = bucket;
    return acc;
  }, {});

export const isAnyFetching = (
  ...queries: (UseQueryResult<unknown, unknown> | undefined)[]
): boolean => queries.some((query) => query?.isFetching);

export const buildSpecs = (
  accounts: ExtendedAccount[],
  globalCurrency: string
): QuerySpec[] =>
  accounts.flatMap((account) => {
    const specs: QuerySpec[] = [
      {
        accountId: account.id,
        currencyType: "global",
        displayCurrency: globalCurrency,
      },
    ];
    if (account.currency && account.currency !== globalCurrency) {
      specs.push({
        accountId: account.id,
        currencyType: "account",
        displayCurrency: account.currency,
      });
    }
    return specs;
  });
